import NP from 'number-precision';
function formatArrOne(testArray, field) {
    const obj = {};
    testArray.forEach(function (items) {
        const str = items[field];
        if (obj[str]) {
            obj[str] = items;
        }
        else {
            obj[str] = items;
        }
    });
    return Object.values(obj);
}
function parseQueryString(url) {
    url = !url ? window.location.href : url;
    if (url.indexOf('?') === -1) {
        return {};
    }
    let search = url[0] === '?' ? url.substr(1) : url.substring(url.lastIndexOf('?') + 1);
    if (search === '') {
        return {};
    }
    search = search.split('&');
    const query = {};
    for (let i = 0; i < search.length; i++) {
        const pair = search[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
}
// 判断是否是微信浏览器
function userAgent() {
    const UserAgent = navigator.userAgent.toLowerCase();
    return /micromessenger/.test(UserAgent);
}
function DateFormat(date, fmt) {
    const o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}
function switchTime(timestamp, type = true, str) {
    if (timestamp == null || timestamp < 10000)
        return '-';
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const t = str == null ? '-' : str;
    if (timestamp > 10000000000) {
        date = new Date(timestamp);
    }
    const Y = date.getFullYear() + t;
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + t;
    const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const h = (date.getHours() < 10 ? ' 0' + date.getHours() : ' ' + date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    if (type)
        return Y + M + D;
    else
        return Y + M + D + h + m + s;
}
function formatId(arr, id, idField, nameField) {
    let name = '';
    if (id == null)
        return name;
    const itemId = idField || 'id';
    const itemName = nameField || 'name';
    arr.forEach((item) => {
        if (item[itemId] == id) {
            name = item[itemName];
        }
    });
    return name;
}
function switchTimestamp(time, flag) {
    if (!time)
        return '';
    time = time.replace(/-/g, '/');
    const t = new Date(time);
    if (flag)
        return Date.parse(t) / 1000;
    return Date.parse(t);
}
function parseData(str, defaultVal) {
    let val = defaultVal;
    try {
        val = JSON.parse(str);
    }
    catch (e) {
        val = defaultVal;
    }
    return val;
}
function isMobile(v) {
    return /^1\d{10}$/.test(v);
}
function isEmail(v) {
    return /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(v);
}
// 去除空格
function removeSpace(v) {
    const re = /\s+/g;
    return v.replace(re, "");
}
// 正整数
function isPositiveInteger(v) {
    return /^[1-9][0-9]*$/.test(v);
}
// 保留2位小数
function isNumber2(v) {
    return /^-?\d+\.?\d{0,2}$/.test(v);
}
// 正整数或0
function isPositiveIntegerAnd0(v) {
    return /^(0|[1-9][0-9]*)$/.test(v);
}
// 正整数或0，最多两位小数
function isPositiveIntegerAnd0With2Decimal(v) {
    return /^\d+(\.\d+)?$/.test(v);
}
// 正数，最多两位小数
function isPositiveNumberWith2Decimal(v) {
    return /^([1-9][0-9]*)|\d+(\.\d{1,2})$/.test(v);
}
// 正数，多位小数
function isPositiveNumber(v) {
    return /^\d+(?=\.{0,1}\d+$|$)/.test(v);
}
// 转换数字
function transformNumber(n) {
    return isNaN(Number(n));
}
// 计算多个数字的和，接收数组参数
function calcTotal(arr) {
    let s = 0;
    arr.map((item) => {
        const flag = transformNumber(item);
        s = NP.plus(s, flag ? 0 : Number(item));
    });
    return s;
}
// 计算多个数字的差，接收数组参数
function calcDiff(arr) {
    const [a1, ...other] = arr;
    let n1 = transformNumber(a1) ? 0 : Number(a1);
    other.map((item) => {
        const flag = transformNumber(item);
        n1 = NP.minus(n1, flag ? 0 : Number(item));
    });
    return n1;
}
// 计算多个数字的积，接收数组参数
function calcTimes(arr) {
    const [a1, ...other] = arr;
    let n1 = transformNumber(a1) ? 0 : Number(a1);
    other.map((item) => {
        const flag = transformNumber(item);
        n1 = NP.times(n1, flag ? 0 : Number(item));
    });
    return n1;
}
// 计算多个数字的除数，接收数组参数
function calcDiv(arr) {
    const [a1, ...other] = arr;
    let n1 = transformNumber(a1) ? 0 : Number(a1);
    other.map((item) => {
        const flag = transformNumber(item);
        if (!flag && Number(item) !== 0) {
            n1 = NP.divide(n1, flag ? 0 : Number(item));
        }
    });
    return n1;
}
// 保留小数位 四舍五入
function calcRound(n, n1) {
    if (transformNumber(n))
        return n;
    return NP.round(n, n1);
}
export default { formatArrOne, parseQueryString, userAgent, DateFormat, switchTime,
    formatId, switchTimestamp, parseData, isMobile, isEmail, removeSpace, isPositiveInteger,
    isNumber2, isPositiveIntegerAnd0, isPositiveIntegerAnd0With2Decimal, isPositiveNumberWith2Decimal, isPositiveNumber,
    transformNumber, calcTotal, calcDiff, calcTimes, calcDiv, calcRound
};
//# sourceMappingURL=utils.js.map